(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facet-filters"] && !Shopify.designMode) return;
  try {
    (function () {
  const MQ = window.matchMedia('(min-width: 1024px)');

  function positionPanel(panel) {
    if (!MQ.matches) {            
      panel.style.left = '';
      panel.style.right = '';
      return;
    }
    
    panel.style.right = 'auto';
    panel.style.left = '0';

    const rect = panel.getBoundingClientRect();
    if (rect.right > window.innerWidth) {  
      panel.style.left = 'auto';
      panel.style.right = '0';
    }
  }

  function handle(details) {
    const panel = details.querySelector(':scope > .disclosure__panel');
    if (details.open && panel) positionPanel(panel);
  }

  document.querySelectorAll('.facets__filters .filter.disclosure').forEach((d) => {
    d.addEventListener('toggle', () => handle(d));
    if (d.open) handle(d); 
  });
  
  let t;
  window.addEventListener('resize', () => {
    clearTimeout(t);
    t = setTimeout(() => {
      document.querySelectorAll('.facets__filters .filter.disclosure[open]').forEach(handle);
    }, 100);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
